export const normalizeToNumber = val => {
  const num = parseInt(val, 10)
  return Number.isInteger(num) ? num : val
}
